"use client";

import React, { useEffect, useState } from "react";
import { useNav } from "../../components/NavigationProvider";
import Spinner from "../../components/Spinner";
import { PORTAL_THEME } from "../../../lib/portal_theme";

const T = PORTAL_THEME;

const CARD = {
  flex: "1 1 260px", maxWidth: 360, cursor: "pointer", textAlign: "left",
  border: T.cardEdge, boxShadow: "none",
  borderRadius: 0, background: T.cardBackground, padding: "22px 20px", color: T.text,
  fontFamily: T.fontFamily, display: "flex", flexDirection: "column", gap: 10,
};

// NIL home, right after sign-in (/nil → /signin → here): manage the store
// they already have, or create a new design for it. Static segment, so it
// wins over /nil/[slug]; store slugs always contain a hyphen anyway.
export default function NilStartPage() {
  const nav = useNav();
  const [state, setState] = useState(null); // { store } | { signIn: true }

  useEffect(() => {
    let cancelled = false;
    fetch("/api/nil/store", { cache: "no-store", credentials: "include" })
      .then((r) => r.json().then((d) => ({ status: r.status, d })))
      .then(({ status, d }) => {
        if (cancelled) return;
        if (status === 401) { window.location.href = "/nil?start=1"; return; }
        setState({ store: d?.store || null });
      })
      .catch(() => { if (!cancelled) setState({ store: null }); });
    return () => { cancelled = true; };
  }, []);

  if (!state) {
    return (
      <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", gap: 10, fontFamily: T.fontFamily, color: T.textMuted }}>
        <Spinner size={18} />Loading…
      </div>
    );
  }

  const option = ({ title, blurb, cta, onClick, disabled }) => (
    <button type="button" style={{ ...CARD, opacity: disabled ? 0.55 : 1, cursor: disabled ? "default" : "pointer" }} onClick={disabled ? undefined : onClick} disabled={disabled}>
      <h2 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>{title}</h2>
      <p style={{ color: T.textMuted, fontSize: 13, lineHeight: 1.6, margin: 0, flex: 1 }}>{blurb}</p>
      <span style={{
        marginTop: 6, padding: "11px 0", borderRadius: 0, textAlign: "center",
        background: T.chromeGradient, textTransform: "uppercase", letterSpacing: "1px", border: T.chromeBorder, boxShadow: T.chromeButtonShadow,
        color: T.chromeButtonText, fontWeight: 700, fontSize: 14,
      }}>{cta}</span>
    </button>
  );

  const { store } = state;
  return (
    <div style={{ minHeight: "100vh", fontFamily: T.fontFamily, color: T.text }}>
      <div style={{ maxWidth: 820, margin: "0 auto", padding: "48px 20px" }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, margin: "0 0 6px", letterSpacing: "-0.5px" }}>Your NIL Store</h1>
        <p style={{ color: T.textMuted, fontSize: 14, margin: "0 0 28px" }}>
          {store ? <>Your store is at <strong style={{ color: T.text }}>{store.url.replace(/^https?:\/\//, "")}</strong>.</> : "Create a design and add it to your store to open it."}
        </p>
        <div style={{ display: "flex", gap: 18, flexWrap: "wrap", alignItems: "stretch" }}>
          {option({
            title: "Manage My Store",
            blurb: store
              ? "See your products and earnings, change prices, remove products and set how you get paid."
              : "You don't have a store yet — it opens with your first Add to Store.",
            cta: "Go to My Store →",
            onClick: () => { window.location.href = store.path; },
            disabled: !store,
          })}
          {option({
            title: "Create a New Design",
            blurb: "Build a new print design and add it to your store on t-shirts, sweatshirts, hoodies, stickers and magnets.",
            cta: "Start Designing →",
            onClick: () => nav.push("/service?flow=print&nil=1"),
          })}
        </div>
        <p style={{ color: T.textMuted, fontSize: 13, margin: "24px 0 0" }}>
          <a href="/nil/about" style={{ color: T.text }}>How the NIL partnership works →</a>
          <span style={{ margin: "0 10px" }}>·</span>
          <a href="/team" style={{ color: T.text }}>Run a team store →</a>
        </p>
      </div>
    </div>
  );
}
